import { CREATE_CRQ } from 'AppSrc/core/components/create-crq-screen/create-crq-screen-consts';
import 'AppSrc/core/style/components/form/form-base-components/select-coordinator-form.css';
import { setCreateCrqCoordinatorGroup, setCreateCrqCoordinator } from 'AppSrc/core/actions/actions-crq-coordinator';
import { connect } from 'react-redux';
import { SelectCoordinatorForm } from 'AppSrc/core/components/forms/select-coordinator/select-coordinator-form';
import { getCoordinatorGroupByName } from 'AppSrc/core/coordinators/coordinator-groups-state-selectors';

const mapStateToProps = (state, ownProps) => {
  const { network } = ownProps;
  const groupName = state.mainForm.formData[CREATE_CRQ].coordinatorGroup;
  const group = getCoordinatorGroupByName({
    state,
    network,
    groupName,
  });
  const groupId = group ? group.id : null;
  const coordinatorId = state.mainForm.formData[CREATE_CRQ].coordinatorId;
  const coordinatorLabel = 'coordinator';
  const groupLabel = 'coordinator group';
  return ({
    groupId,
    coordinatorId,
    coordinatorLabel,
    groupLabel,
  });
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  setGroup(group) {
    const groupName = group ? group.name : null;
    dispatch(setCreateCrqCoordinatorGroup(groupName));
  },
  setCoordinator(coordinator) {
    dispatch(setCreateCrqCoordinator(coordinator));
  },
});

const SelectCrqCoordinatorForm = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectCoordinatorForm);

export { SelectCrqCoordinatorForm };
